/* eslint-disable @typescript-eslint/no-explicit-any */
import isFunction from 'lodash/isFunction';
import { useState } from 'react';

import useMemoizedFn from '@/utils/useMemoizedFn';
//useSetState works similar to this.setState of class component, used to manage the state of object type.
//https://ahooks.js.org/hooks/use-set-state/

export type SetState<S extends Record<string, any>> = <K extends keyof S>(
  state:
    | Pick<S, K>
    | null
    | ((prevState: Readonly<S>) => Pick<S, K> | S | null),
) => void;

const useSetState = <S extends Record<string, any>>(
  initialState: S | (() => S),
): [S, SetState<S>] => {
  const [state, setState] = useState<S>(initialState);

  const setMergeState = useMemoizedFn((patch) => {
    setState((prevState) => {
      const newState = isFunction(patch) ? patch(prevState) : patch;
      return newState ? { ...prevState, ...newState } : prevState;
    });
  });

  return [state, setMergeState];
};

export default useSetState;
